import React from 'react'
import { UserIcon } from '../../user/user-icon/UserIcon'
import { dayjsFromNow } from 'shared/dayjs'
import { UserDetailFragment } from 'front-end/src/public-api/hooks/usePublicApiSession.codegen'

const CommentHeader = ({
  author,
  createdAt
}: {
  author: UserDetailFragment
  createdAt?: string
}) => {
  return (
    <div className="comment-header">
      <div className="comment-author">
        <UserIcon user={author} showTooltip />
        {author.display_name}
      </div>
      {createdAt ? (
        <div className="comment-date">{dayjsFromNow(createdAt)}</div>
      ) : null}
    </div>
  )
}

export default CommentHeader
